import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import PencilIcon from '../../../Icons/Pencil';
import ActionBarButton from '../../_partials/ActionBarButton';
import ActionBarIcon from '../../_partials/ActionBarIcon';
import { getDeviationType } from '../../../DeviationViews/_helpers';
import { MobileContext } from '../../../Context';
import { DeviationTypes } from '../../../types/deviation';
export var EditButton = function (_a) {
    var deviation = _a.deviation, onClick = _a.onClick;
    var t = useTranslation().t;
    var isMobile = useContext(MobileContext);
    var type = getDeviationType(deviation);
    var canEdit = deviation.extended &&
        deviation.extended.canUserEdit &&
        !(isMobile &&
            [DeviationTypes.JOURNAL, DeviationTypes.LITERATURE].includes(type) &&
            deviation.textContent &&
            deviation.textContent.html.type === 'draft');
    if (!canEdit) {
        return null;
    }
    return (React.createElement(ActionBarButton, { tooltip: t('actionbar.edit'), onClick: function () {
            onClick({ deviation: deviation });
        }, isEditAction: true },
        React.createElement(ActionBarIcon, { icon: PencilIcon })));
};
EditButton.displayName = 'EditButton';
export default EditButton;
//# sourceMappingURL=EditButton.js.map